/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { permissionCheck } from '../../../../../app/helper-functions/PermissionCheck'
import { KTIcon } from '../../../../helpers'
var user_create,user_update,user_delete,user_view, user_activity_log
var role_create,role_update,role_delete,role_view,role_activity_log
var application_create,application_update,application_delete,application_view,application_activity_log
var user_application_create,user_application_update,user_application_delete,user_application_view,user_application_activity_log;
var project_create, project_update, project_delete, project_view, project_activity_log
var subproject_create, subproject_update, subproject_delete, subproject_view, subproject_activity_log
var category_create, category_update, category_delete, category_view, category_activity_log
var subcategory_create, subcategory_update, subcategory_delete, subcategory_view, subcategory_activity_log
var tag_create, tag_update, tag_delete, tag_view, tag_activity_log
var platform_create, platform_update, platform_delete, platform_view, platform_activity_log
var upload_create, upload_update, upload_delete, upload_view, upload_activity_log
var download_create, download_update, download_delete, download_view, download_activity_log
var settings_view, settings_update, settings_activity_log

const SidebarMenuMain = () => {
  const intl = useIntl()
  user_create = permissionCheck('user-create');
  user_update = permissionCheck('user-update');
  user_delete = permissionCheck('user-delete');
  user_view = permissionCheck('user-view');
  user_activity_log = permissionCheck('user-activity-log');
  role_create = permissionCheck('role-create');
  role_update = permissionCheck('role-update');
  role_delete = permissionCheck('role-delete');
  role_view = permissionCheck('role-view');
  role_activity_log = permissionCheck('role-activity-log');
  application_create = permissionCheck('application-create');
  application_update = permissionCheck('application-update');
  application_delete = permissionCheck('application-delete');
  application_view = permissionCheck('application-view');
  application_activity_log = permissionCheck('application-activity-log');
  user_application_create = permissionCheck('user-application-create');
  user_application_update = permissionCheck('user-application-update');
  user_application_delete = permissionCheck('user-application-delete');
  user_application_view = permissionCheck('user-application-view');
  user_application_activity_log = permissionCheck('user-application-activity-log');
  project_create = permissionCheck('project-create');
  project_update = permissionCheck('project-update');
  project_delete = permissionCheck('project-delete');
  project_view = permissionCheck('project-view');
  project_activity_log = permissionCheck('project-activity-log');
  subproject_create = permissionCheck('subproject-create');
  subproject_update = permissionCheck('subproject-update');
  subproject_delete = permissionCheck('subproject-delete');
  subproject_view = permissionCheck('subproject-view');
  subproject_activity_log = permissionCheck('subproject-activity-log');
  category_create = permissionCheck('category-create');
  category_update = permissionCheck('category-update');
  category_delete = permissionCheck('category-delete');
  category_view = permissionCheck('category-view');
  category_activity_log = permissionCheck('category-activity-log');
  subcategory_create = permissionCheck('subcategory-create');
  subcategory_update = permissionCheck('subcategory-update');
  subcategory_delete = permissionCheck('subcategory-delete');
  subcategory_view = permissionCheck('subcategory-view');
  subcategory_activity_log = permissionCheck('subcategory-activity-log');
  tag_create = permissionCheck('tag-create');
  tag_update = permissionCheck('tag-update');
  tag_delete = permissionCheck('tag-delete');
  tag_view = permissionCheck('tag-view');
  tag_activity_log = permissionCheck('tag-activity-log');
  platform_create = permissionCheck('platform-create');
  platform_update = permissionCheck('platform-update');
  platform_delete = permissionCheck('platform-delete');
  platform_view = permissionCheck('platform-view');
  platform_activity_log = permissionCheck('platform-activity-log');
  upload_create = permissionCheck('upload-create');
  upload_update = permissionCheck('upload-update');
  upload_delete = permissionCheck('upload-delete');
  upload_view = permissionCheck('upload-view');
  upload_activity_log = permissionCheck('upload-activity-log');
  download_create = permissionCheck('download-create');
  download_update = permissionCheck('download-update');
  download_delete = permissionCheck('download-delete');
  download_view = permissionCheck('download-view');
  download_activity_log = permissionCheck('download-activity-log');
  settings_view = permissionCheck('settings-view');
  settings_update = permissionCheck('settings-update');
  settings_activity_log = permissionCheck('settings-activity-log');
  
  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      {(upload_view || upload_create) && (
        <SidebarMenuItemWithSub
          to='/digital-assets'
          title='Digital Assets'
          icon='abstract-38'
          fontIcon='bi-folder2-open'
        >
          {upload_view && <SidebarMenuItem to='/digital-assets' title='List Assets' hasBullet={true} />}
          {upload_create && (
            <SidebarMenuItem to='/digital-assets/upload' title='Upload Asset' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
      {project_view && (
        <SidebarMenuItemWithSub
          to='/projects'
          title='Projects'
          icon='abstract-26'
          fontIcon='bi-folder'
        >
          {project_view && <SidebarMenuItem to='/projects/list' title='All Projects' hasBullet={true} />}
          {project_view && <SidebarMenuItem to='/projects/starred' title='Starred Projects' hasBullet={true} />}
          {/* {project_activity_log && <SidebarMenuItem to='/projects/projects-logs' title='Activity Logs' hasBullet={true} />} */}
        </SidebarMenuItemWithSub>
      )}
      {(category_view || category_create) && (
        <SidebarMenuItemWithSub
          to='/categories'
          title='Categories'
          icon='category'
          fontIcon='bi-tags'
        >
          {category_view && <SidebarMenuItem to='/categories' title='List Categories' hasBullet={true} />}
          {category_create && (
            <SidebarMenuItem to='/categories/add' title='Add Category' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
      {(subcategory_view || subcategory_create) && (
        <SidebarMenuItemWithSub
          to='/subcategories'
          title='Subcategories'
          icon='category'
          fontIcon='bi-tag-fill'
        >
          {subcategory_view && <SidebarMenuItem to='/subcategories' title='List Subcategories' hasBullet={true} />}
          {subcategory_create && (
            <SidebarMenuItem to='/subcategories/add' title='Add Subcategory' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
      {(tag_view || tag_create) && (
        <SidebarMenuItemWithSub
          to='/tags'
          title='Tags'
          icon='category'
          fontIcon='bi-tag'
        >
          {tag_view && <SidebarMenuItem to='/tags' title='List Tags' hasBullet={true} />}
          {tag_create && (
            <SidebarMenuItem to='/tags/add' title='Add Tag' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
      {(platform_view || platform_create) && (
        <SidebarMenuItemWithSub
          to='/platforms'
          title='Platforms'
          icon='abstract-38'
          fontIcon='bi-laptop'
        >
          {platform_view && <SidebarMenuItem to='/platforms' title='List Platforms' hasBullet={true} />}
          {platform_create && (
            <SidebarMenuItem to='/platforms/add' title='Add Platform' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
      {(role_view || role_create || role_activity_log) && (
        <SidebarMenuItemWithSub
          to='/roles'
          title='Roles'
          icon='abstract-28'
          fontIcon='bi-shield-check'
        >
          {role_view && <SidebarMenuItem to='/roles/roles-list' title='Roles List' hasBullet={true} />}
          {role_create && <SidebarMenuItem to='/roles/add-role' title='Add Role' hasBullet={true} />}
          {/* {role_activity_log && <SidebarMenuItem to='/roles/logs' title='Activity Logs' hasBullet={true} />} */}
        </SidebarMenuItemWithSub>
      )}
      {(user_view || user_create || user_activity_log) && (
        <SidebarMenuItemWithSub 
          to='/users'
          title='Users'
          icon='abstract-28'
          fontIcon='bi-people'
        >
          {user_view && <SidebarMenuItem to='/users/users-list' title='Users List' hasBullet={true} />}
          {user_create && <SidebarMenuItem to='/users/add-user' title='Add User' hasBullet={true} />}
          {/* {user_activity_log && <SidebarMenuItem to='/users/user-logs' title='Activity Logs' hasBullet={true} />} */}
        </SidebarMenuItemWithSub>
      )}
      {/* {(settings_view || 1) && (
        <SidebarMenuItem
          to='/settings'
          title='Settings'
          icon='profile-circle'
          fontIcon='bi-gear'
        />
      )} */}
      {/* <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User Management'
        fontIcon='bi-layers'
      /> */}
      {/* <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export { SidebarMenuMain }
